export default __webpack_public_path__ + "static/media/anne-frank.4b8ea4e3.png";